module.exports = __webpack_public_path__ + "static/media/flower-leatherworking-tool.cefa601b.webp";